/// <reference path="../../_ext/editors/BOMGridEditor.ts" />

namespace TabAurous.Inventory {
    import fld = CertificationIssueBOMRow.Fields;


    @Serenity.Decorators.registerClass()
    export class CertificationIssueBOMEditor extends _Ext.BOMGridEditor<CertificationIssueBOMRow> { 
        protected getDialogType() { return CertificationIssueBOMDialog; }
        protected getLocalTextPrefix() { return CertificationIssueBOMRow.localTextPrefix; }
        
         
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });         
            
        } 
    }
}